export const API_BASE_URL = "https://haircation.com/wp-json/";
